function getCurrentLangFromCookie() {
  const langCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("googtrans="));

  if (langCookie) {
    return langCookie.split("=")[1].split("/")[2]; // ex: "/fr/en" → "en"
  }

  return null;
}
const show = (elements) => {
  Array.from(elements).forEach((el) => el.classList.remove("d-none"));
};

const hide = (elements) => {
  Array.from(elements).forEach((el) => el.classList.add("d-none"));
};

const showBaner = (currentLang) => {
  const banners = document.getElementsByClassName("c-banner");
  const partialBanners = document.getElementsByClassName("partialBanners");

  for (let banner of banners) {
    if (currentLang && currentLang !== "fr") {
      banner.classList.remove("d-none");
    } else {
      banner.classList.add("d-none");
    }
  }

  for (let banner of partialBanners) {
    if (currentLang && currentLang !== "fr") {
      banner.classList.add("en");
      console.log("fr");
    } else {
      banner.classList.remove("en");
    }
  }
};

const translateForm = (currentLang) => {
  const frenchFormDevenirLoc = document.getElementsByClassName("french-form");
  const englishFormDevenirLoc = document.getElementsByClassName("english-form");

  if (currentLang && currentLang !== "fr") {
    show(englishFormDevenirLoc);
    hide(frenchFormDevenirLoc);
  } else {
    show(frenchFormDevenirLoc);
    hide(englishFormDevenirLoc);
  }
};

function showInEnglish() {
  const currentLang = getCurrentLangFromCookie();

  showBaner(currentLang);
  translateForm(currentLang);
}

function protectQuebec() {
  const regex = /\bQuebec\b/g;

  document.querySelectorAll("body *:not(script):not(style)").forEach((el) => {
    if (el.children.length === 0) {
      if (el.textContent.includes("Quebec")) {
        el.textContent = el.textContent.replace(regex, "Québec");
      }
    }
  });
}
const observer = new MutationObserver(() => {
  protectQuebec();
});

function notranslateElements(classNames) {
  document.addEventListener("DOMContentLoaded", function () {

    classNames.forEach(className => {
      const elements = document.querySelectorAll(`.${className}`);

      elements.forEach(el => {
        el.classList.add("notranslate");
        el.setAttribute("translate", "no");
      });
    });

  });
}

// Exécuter une fois au chargement
showInEnglish();
notranslateElements(["menu-item-164", "menu-item-155"]); 


observer.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true
});

// Surveiller les changements de langue (ex. via Google Translate)
let lastLang = getCurrentLangFromCookie();

setInterval(() => {
  const newLang = getCurrentLangFromCookie();
  if (newLang !== lastLang) {
    lastLang = newLang;
    showInEnglish();
  }
}, 500); // vérifie toutes les 1 seconde
